import { Component, Input, OnInit, ViewContainerRef } from '@angular/core';

export enum SpinnerSize {
  Tiny = 'Tiny',
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
  Big = 'Big'
}

@Component({
    selector: 'odq-loading-spinner',
    template: `
    <div>
      <mat-spinner
        class="odq-spinner-center"
        [diameter]="diameterSize"
        color="accent"
      ></mat-spinner>
      <div style="font-style: italic;font-size: small;">{{ spinnerText }}</div>
    </div>
  `,
    standalone: false
})
export class LoadingSpinnerComponent implements OnInit {
  @Input() size: SpinnerSize;
  @Input() spinnerText: string;

  public diameterSize = 70;
  constructor(public vcRef: ViewContainerRef) {}

  ngOnInit(): void {
    switch (this.size) {
      case SpinnerSize.Tiny:
        this.diameterSize = 20;
        break;
      case SpinnerSize.Small:
        this.diameterSize = 30;
        break;
      case SpinnerSize.Medium:
        this.diameterSize = 50;
        break;
      case SpinnerSize.Large:
        this.diameterSize = 70;
        break;
      case SpinnerSize.Big:
        this.diameterSize = 100;
        break;
    }
  }
}
